import dayjs from 'dayjs'
import Dialog from 'global/guides/Dialog'
import { useEscalasOutletContext } from 'pages/Escalas'
import { Outlet, useParams } from 'react-router-dom'
import FormularioAssocioarFuncionarioEscala from '../forms/AssociarFuncionario'

export default function AssociarFuncionarios() {
    const { id } = useParams()
    const { data } = useEscalasOutletContext()
    const find = data.find(item => item.id === Number(id))

    return (
        <Dialog.Root
            height="auto"
            defaultValues={{
                ...find,
                dtInicial: dayjs().format('YYYY-MM-DD'),
            }}
        >
            <Dialog.Title>Funcionários {find?.descricao}</Dialog.Title>
            <Dialog.Content dividers>
                <FormularioAssocioarFuncionarioEscala />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton>
                    Fechar
                </Dialog.Actions.SecondaryButton>
            </Dialog.Actions>
            <Outlet />
        </Dialog.Root>
    )
}
